import apiClient from '../api';

export const getBoxAssets = (data) => apiClient.post('/box-assets/assets', data);
export const createBoxAssets = (data) => apiClient.post('/box-assets/create', data);
export const downloadZipFromBox = (data) => apiClient.post('/box-assets/download/archive', data);
export const deleteAssets = (data) => apiClient.post('/box-assets/delete', data);
export const uploadAssetToBox = (data) => apiClient.post('/box-assets/upload', data);
export const changeAssetStatus = (data) => apiClient.put('/box-assets/change/status', data);

export const downloadFileFromBox = (id) => apiClient.get(`/box-assets/download/file/${id}`);

export const getBoxAccessToken = () => apiClient.get('/box/get/access/token');
